import React from 'react';
import cls from './executorItem.module.css';
import { Icon } from 'shared/ui';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

interface ExecutorItemProps {
    avatarUrl: string;
    name: string;
    toggleDropdown: () => void;
    isDisabled: boolean;
}

export function ExecutorItem({ avatarUrl, name, toggleDropdown, isDisabled }: ExecutorItemProps) {
    const { t } = useTranslation();
    return (
        <div onClick={toggleDropdown} className={cls.executorItem}>
            {!avatarUrl ? (
                <span className={cls.executorAvatar}>
                    <Icon iconName={'profile'} />
                </span>
            ) : (
                <img
                    className={cls.executorAvatar}
                    src={avatarUrl}
                    alt={`${t('Features.ExecutorItem.imgAlt.text')} ${name}`}
                />
            )}
            <span className={cn(cls.executorName, { [cls.disabled]: isDisabled })}>{name}</span>
        </div>
    );
}
